/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import React, { useState } from 'react';
import { Form, InputGroup } from 'react-bootstrap';
import * as S from '../../styles';

export interface IEmailInputProps {
  id: string;
  label?: string;
  labelColor?: string;
  errorText?: string;
  errorText1?: string;
  value?: string;
  required?: boolean;
  placeholder?: string;
  readOnly?: boolean;
  hasError?: boolean;
  onCompChange?(id: string, payload: any): void;
}

export const EmailInput = ({
  id,
  label,
  labelColor,
  errorText,
  errorText1,
  value,
  required,
  placeholder,
  readOnly,
  hasError,
  onCompChange,
}: IEmailInputProps) => {
  const [textValue, setTextValue] = useState(value ?? '');

  const onChange = (id: string, e: any) => {
    setTextValue(e?.target?.value);
    onCompChange && onCompChange(id, e?.target?.value);
  };

  const _renderLabelIf = () => {
    if (label) {
      return (
        <S.FormLabel color={labelColor}>
          {label}
          {required && <sup style={{ color: 'red' }}>*</sup>}
        </S.FormLabel>
      );
    }
    return null;
  };

  const _renderErrorTextIf = () => {
    if (hasError && errorText) {
      return <S.FeedbackLabel type="invalid">{errorText}</S.FeedbackLabel>;
    }
    return null;
  };

  return (
    <Form.Group id={id}>
      {_renderLabelIf()}
      <Form.Control
        inputMode="email"
        type="email"
        value={textValue}
        onChange={onChange.bind(null, id)}
        required={required}
        placeholder={placeholder}
        readOnly={readOnly}
        isInvalid={hasError}
        pattern="[^\s@]+@[^\s@]+\.[^\s@]+"
      />
      {_renderErrorTextIf()}
    </Form.Group>
  );
};

EmailInput.defaultProps = {
  required: false,
  hasError: false,
};
